import React from "react";
import { useNavigate } from "react-router-dom";
import "./LegalPage.css";
import hiveLogo from "../../assets/logos/hive_logo_normal.webp";
import Footer from "../footer/Footer";

const Terms = () => {
  const navigate = useNavigate();

  return (
    <div className="legal-page">
      <div className="legal-shell">
        <div className="legal-nav">
          <div className="legal-nav-left">
            <img src={hiveLogo} alt="Hive Team" />
            <h1>Terms and Conditions</h1>
          </div>
          <button className="legal-home-btn" onClick={() => navigate("/")}>
            Back to Home
          </button>
        </div>

        <div className="legal-card">
          <h2>Terms and Conditions</h2>
          <p>Last updated: [add date]</p>
          <p>
            These Terms and Conditions govern the use of the HiveTeam website
            and services, operated by Lupus Development SRL, under the brand
            HiveTeam. By accessing our website or using our services, you agree
            to these Terms in full. If you do not agree with any part of these
            Terms, you must not use our services.
          </p>
        </div>

        <div className="legal-card">
          <h2>1. Company Information</h2>
          <ul>
            <li>Company Name: Lupus Development SRL</li>
            <li>Brand Name: HiveTeam</li>
            <li>CUI: 50595916</li>
            <li>Website: https://hiveteam.dev</li>
            <li>Contact Email: office@hiveteam.dev</li>
            <li>
              Primary Communication Channel: Official HiveTeam Discord server
            </li>
          </ul>
        </div>

        <div className="legal-card">
          <h2>2. Services Provided</h2>
          <ul>
            <li>Website design and development.</li>
            <li>Game server development (FiveM, RageMP, RedM, etc.).</li>
            <li>Hosting services (VPS, dedicated servers, game hosting).</li>
            <li>Graphic design and UI/UX services.</li>
            <li>Custom software and scripting solutions.</li>
            <li>
              The exact scope of services is agreed individually with each
              client.
            </li>
          </ul>
        </div>

        <div className="legal-card">
          <h2>3. Eligibility</h2>
          <ul>
            <li>
              Be at least 18 years old, or have legal permission from a parent
              or guardian.
            </li>
            <li>Have the legal capacity to enter a binding agreement.</li>
          </ul>
        </div>

        <div className="legal-card">
          <h2>4. Orders & Agreements</h2>
          <ul>
            <li>
              All service requests are confirmed via written agreement (Discord,
              email, or invoice).
            </li>
            <li>
              Once a project has started, cancellation may not be possible.
            </li>
            <li>
              Any additional requests outside the original scope may require
              extra payment.
            </li>
          </ul>
        </div>

        <div className="legal-card">
          <h2>5. Payments & Pricing</h2>
          <ul>
            <li>Prices are agreed upon before project initiation.</li>
            <li>
              Payments may be required upfront, partially, or in full, depending
              on the service.
            </li>
            <li>
              All payments are non-refundable once work has begun, unless
              otherwise stated in writing.
            </li>
            <li>
              Failure to complete payment may result in service suspension or
              termination.
            </li>
          </ul>
        </div>

        <div className="legal-card">
          <h2>6. Delivery & Deadlines</h2>
          <ul>
            <li>Estimated delivery times are provided in good faith.</li>
            <li>
              Delays caused by client inactivity, missing information, or
              third-party services are not our responsibility.
            </li>
            <li>
              HiveTeam is not liable for delays caused by force majeure or
              external service providers.
            </li>
          </ul>
        </div>

        <div className="legal-card">
          <h2>7. Intellectual Property</h2>
          <ul>
            <li>
              All custom work remains the property of HiveTeam until full
              payment is received.
            </li>
            <li>
              After full payment, ownership rights are transferred to the client
              unless otherwise agreed.
            </li>
            <li>
              HiveTeam reserves the right to showcase completed projects in its
              portfolio unless the client explicitly requests otherwise.
            </li>
          </ul>
        </div>

        <div className="legal-card">
          <h2>8. Hosting & Server Services</h2>
          <ul>
            <li>
              Abuse, illegal content, or malicious activity is strictly
              prohibited.
            </li>
            <li>
              We reserve the right to suspend or terminate services without
              refund if abuse is detected.
            </li>
            <li>
              Clients are responsible for the content hosted on their servers.
            </li>
          </ul>
        </div>

        <div className="legal-card">
          <h2>9. Client Responsibilities</h2>
          <ul>
            <li>Provide accurate and complete information.</li>
            <li>Respond in a timely manner during project development.</li>
            <li>
              Use delivered services and products legally and responsibly.
            </li>
          </ul>
          <p>
            HiveTeam is not responsible for issues caused by misuse or
            unauthorized modifications.
          </p>
        </div>

        <div className="legal-card">
          <h2>10. Limitation of Liability</h2>
          <ul>
            <li>We are not liable for indirect or consequential damages.</li>
            <li>
              We are not liable for loss of revenue, data, or business
              opportunities.
            </li>
            <li>
              We are not liable for downtime caused by third-party services or
              force majeure events.
            </li>
          </ul>
          <p>
            Our liability is limited to the amount paid for the specific
            service.
          </p>
        </div>

        <div className="legal-card">
          <h2>11. Termination</h2>
          <ul>
            <li>
              We may terminate or suspend access if these Terms are violated.
            </li>
            <li>
              We may terminate or suspend access if payments are not completed.
            </li>
            <li>
              We may terminate or suspend access if illegal or abusive activity
              is detected.
            </li>
          </ul>
        </div>

        <div className="legal-card">
          <h2>12. Privacy</h2>
          <p>
            Use of our services is also governed by our Privacy Policy, which
            explains how we collect and process personal data in accordance with
            GDPR.
          </p>
        </div>

        <div className="legal-card">
          <h2>13. Governing Law</h2>
          <p>
            These Terms are governed by the laws of Romania. Any disputes shall
            be resolved by the competent Romanian courts.
          </p>
        </div>

        <div className="legal-card">
          <h2>14. Changes to These Terms</h2>
          <p>
            HiveTeam reserves the right to update or modify these Terms at any
            time. Changes take effect immediately upon publication on the
            website.
          </p>
        </div>

        <div className="legal-card">
          <h2>15. Contact</h2>
          <p>
            For any questions regarding these Terms and Conditions, contact us
            at office@hiveteam.dev.
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Terms;
